import {
  FETCH_AUCTION_STARTED,
  FETCH_AUCTION_COMPLETED,
  FETCH_AUCTION_ERROR,
  FILTER_AUCTION_STARTED,
  FILTER_AUCTION_COMPLETED,
  FILTER_AUCTION_ERROR,
  FETCH_COLLECTION_STARTED,
  FETCH_COLLECTION_COMPLETED,
  FETCH_COLLECTION_ERROR,
  FILTER_COLLECTION_STARTED,
  FILTER_COLLECTION_COMPLETED,
  FILTER_COLLECTION_ERROR,
  CLEAR_COLLECTIONS
} from '../actionTypes/reportActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  auctions: {},
  collections: {}
};

function reportReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_AUCTION_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_AUCTION_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          auctions: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_AUCTION_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FILTER_AUCTION_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FILTER_AUCTION_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          auctions: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FILTER_AUCTION_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_COLLECTION_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_COLLECTION_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          collections: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_COLLECTION_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FILTER_COLLECTION_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FILTER_COLLECTION_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          collections: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FILTER_COLLECTION_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case CLEAR_COLLECTIONS: {
      return {
        ...state,
        collections: {},
        submitted: false,
        success: true
      };
    }
    default:
      return state;
  }
}

export default reportReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/reportReducer.js